export default {
  namespaced: true,
  state: {
    // 消息通知是否存在未读
    messageNotificationUnreadStatus: false,
  },
  getters: {
    // 消息通知是否已读（综合状态，包括消息通知和网站维护通知）（true：存在未读，false：全部已读）
    messageComprehensiveUnreadStatus(state, _, rootState) {
      return state.messageNotificationUnreadStatus || rootState.siteNoticeIsRead
    },
    // 前台帮助中心权限
    helpCenterPermission_front(state, getters, rootState, rootGetters) {
      // console.log(state, getters, rootState, rootGetters);
      const exist = rootGetters.functionalPermissions.find((item) => item.code === 'pms:front_help_center')
      return exist ? true : false
    },
    // 前台常见问答权限
    commonQAPermission_front(_, __, ___, rootGetters) {
      const exist = rootGetters.functionalPermissions.find((item) => item.code === 'pms:front_faq')
      return exist ? true : false
    },
    // 前台操作指引权限
    guidePermission_front(_, __, ___, rootGetters) {
      const exist = rootGetters.functionalPermissions.find((item) => item.code === 'pms:front_guide')
      return exist ? true : false
    },
    // 前台我的建议权限
    advicePermission_front(_, __, ___, rootGetters) {
      const exist = rootGetters.functionalPermissions.find((item) => item.code === 'pms:front_advice')
      return exist ? true : false
    },
    // 前台消息通知权限
    messagePermission_front(_, __, ___, rootGetters) {
      const exist = rootGetters.functionalPermissions.find((item) => item.code === 'pms:front_message')
      return exist ? true : false
    },
    // 前台咨询顾问权限
    consultantPermission_front(_, __, ___, rootGetters) {
      const exist = rootGetters.functionalPermissions.find((item) => item.code === 'pms:front_consultant')
      return exist ? true : false
    },
    // 后台帮助中心权限
    helpCenterPermission_back(_, __, ___, rootGetters) {
      const exist = rootGetters.functionalPermissions.find((item) => item.code === 'pms:background_help_center')
      return exist ? true : false
    },
    // 后台常见问答权限
    commonQAPermission_back(_, __, ___, rootGetters) {
      const exist = rootGetters.functionalPermissions.find((item) => item.code === 'pms:background_faq')
      return exist ? true : false
    },
    // 后台操作指引权限
    guidePermission_back(_, __, ___, rootGetters) {
      const exist = rootGetters.functionalPermissions.find((item) => item.code === 'pms:background_guide')
      return exist ? true : false
    },
    // 后台我的建议权限
    advicePermission_back(_, __, ___, rootGetters) {
      const exist = rootGetters.functionalPermissions.find((item) => item.code === 'pms:background_advice')
      return exist ? true : false
    },
    // 后台消息通知权限
    messagePermission_back(_, __, ___, rootGetters) {
      const exist = rootGetters.functionalPermissions.find((item) => item.code === 'pms:background_message')
      return exist ? true : false
    },
    // 后台咨询顾问权限
    consultantPermission_back(_, __, ___, rootGetters) {
      const exist = rootGetters.functionalPermissions.find((item) => item.code === 'pms:background_consultant')
      return exist ? true : false
    },
  },
  mutations: {
    // 设置消息通知未读状态
    setMessageNotificationUnreadStatus(state, status) {
      state.messageNotificationUnreadStatus = status
    }
  },
  actions: {},
}